<template>
  <h-dialog
    v-model="visible"
    title="选择店铺"
    class="modal"
    @onOk="ok"
    @onCancel="close"
    width="520px"
    align-center
  >
    <el-radio-group v-model="mct_id" style="width: 100%" @change="mctChange">
      <section class="container">
        <h-table
          vuexNamespace="business-components-choose-shop-btn"
          ref="tableRef"
          row-key="id"
          :columns="columns"
          :showQuery="false"
          :showReset="false"
          :http="getList"
          :queryForm="queryForm"
          pagPayout="prev, pager, next"
          @result="getResult"
          :auto-request="false"
        >
          <template #shop_name="{ row }">
            <el-radio :value="row.id">
              {{ row.shop_name }}
            </el-radio>
          </template>
        </h-table>
      </section>
    </el-radio-group>
  </h-dialog>
  <section class="form-item-container">
    <el-input
      readOnly
      allowClear
      :value="chooseMct && chooseMct.shop_name"
      placeholder="请选择店铺"
      @click="show"
    >
      <template #suffix>
        <el-icon class="close-circle" v-if="chooseMct" @click="clearChoose">
          <CircleCloseFilled />
        </el-icon>
      </template>
    </el-input>
  </section>
</template>

<script setup>
import { shopList } from '@/api/shop-manager/shop-list'
import { ref, unref, nextTick } from 'vue'
import { ElMessage } from 'element-plus'

const chooseMct = ref(null), // 选择的店铺
  chooseMctCopy = ref(null),
  tableRef = ref(),
  visible = ref(false),
  mct_id = ref(),
  dataSource = ref([]),
  queryForm = ref({
    formItems: [
      {
        key: 'name',
        type: 'input',
        placeholder: '输入店铺名称搜索',
      },
    ],
  })

const emit = defineEmits(['refreshTable'])

const columns = [
  {
    prop: 'shop_name',
    label: '店铺名称',
    scopedSlots: 'shop_name',
    showOverflowTooltip: true,
  },
  {
    prop: 'cabinet_code',
    label: '设备编号',
    showOverflowTooltip: true,
  },
  {
    prop: 'org_name',
    label: '所属组织',
    showOverflowTooltip: true,
  },
]

function mctChange(id) {
  const mct = dataSource.value.find((item) => item.id === id)
  chooseMctCopy.value = { ...mct }
}

function getList(params) {
  return shopList(params)
}
function setChooseItem(row) {
  chooseMct.value = row
}
async function show() {
  visible.value = true
  await nextTick()
  unref(tableRef).refresh()
}
function close() {
  visible.value = false
  chooseMctCopy.value = null
  setTimeout(() => {
    mct_id.value = undefined
  }, 300)
}
function getResult(rs) {
  dataSource.value = rs.data.rows
}
// 清除店铺
function clearChoose(flag) {
  chooseMct.value = null
  mct_id.value = undefined
  if (flag) {
    emit('refreshTable')
  }
}
function ok() {
  if (chooseMctCopy.value) {
    chooseMct.value = {
      ...unref(chooseMctCopy),
    }
    console.log(unref(chooseMctCopy), 'unref(chooseMctCopy)')

    emit('refreshTable', unref(chooseMctCopy))
    close()
  } else {
    ElMessage.error('请选择店铺')
  }
}

// 设置值
function setValue(value) {
  chooseMct.value = value
}

defineExpose({
  setChooseItem,
  setValue,
  clearChoose
})
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  .x-table-page {
    padding: 0;
    :deep(.x-form) {
      padding: 0;
      margin: 0;
    }
    :deep(.x-table) {
      padding-right: 0;
    }
  }
  .form-item-container {
    width: 100%;
  }
}
:deep(.el-row) {
  .form-row {
    min-width: 100%;
    padding-right: 0 !important;
  }
}
.close-circle {
  cursor: pointer;
}
</style>
